(function () {

  'use strict';

  function pxTestCloudStorage(
    $timeout, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        cloudstorage: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/cloudStorage/testCloudStorage/testCloudStorage.template.html',
      link: function (scope) {

        scope.steps = {
          CONNECTION: 'pending',
          UPLOAD: 'pending',
          DOWNLOAD: 'pending',
          DELETE: 'pending',
          WORKING: 'pending',
        };

        scope.cloudstorage.testCloudStorage(scope.cloudstorage).then(function (response) {
          switch (response.data.result) {
            case 'WORKING':
              scope.steps.CONNECTION = 'success';
              scope.steps.UPLOAD = 'success';
              scope.steps.DOWNLOAD = 'success';
              scope.steps.DELETE = 'success';
              scope.steps.WORKING = 'success';
              break;
            case 'CONNECTION_FAILED':
              scope.steps.CONNECTION = 'failed';
              scope.steps.UPLOAD = 'stopped';
              scope.steps.DOWNLOAD = 'stopped';
              scope.steps.DELETE = 'stopped';
              scope.steps.WORKING = 'failed';
              break;
            case 'UPLOAD_FAILED':
              scope.steps.CONNECTION = 'success';
              scope.steps.UPLOAD = 'failed';
              scope.steps.DOWNLOAD = 'stopped';
              scope.steps.DELETE = 'stopped';
              scope.steps.WORKING = 'failed';
              break;
            case 'DOWNLOAD_FAILED':
              scope.steps.CONNECTION = 'success';
              scope.steps.UPLOAD = 'success';
              scope.steps.DOWNLOAD = 'failed';
              scope.steps.DELETE = 'stopped';
              scope.steps.WORKING = 'failed';
              break;
            case 'DELETE_FAILED':
              scope.steps.CONNECTION = 'success';
              scope.steps.UPLOAD = 'success';
              scope.steps.DOWNLOAD = 'success';
              scope.steps.DELETE = 'failed';
              scope.steps.WORKING = 'failed';
              break;
          }
        }).catch(function(error){});

        scope.closeAndExit = function () {
          scope.callback();
        };

        scope.testAgain = function () {
          scope.callback();
          $timeout(() => {
            $rootScope.$broadcast('TEST_CLOUD_STORAGE', { cloudstorage: scope.cloudstorage });
          }, 300);
        };

        scope.modifyName = function () {
          scope.callback();
          $timeout(() => {
            $rootScope.$broadcast('MODIFY_CLOUD_STORAGE_NAME', { cloudstorage: scope.cloudstorage });
          }, 300);
        };

        scope.modifyKey = function () {
          scope.callback();
          $timeout(() => {
            $rootScope.$broadcast('MODIFY_CLOUD_STORAGE_KEY', { cloudstorage: scope.cloudstorage });
          }, 300);
        };

        scope.modifyStorageDetails = function () {
          scope.callback();
          $timeout(() => {
            $rootScope.$broadcast('MODIFY_S3_DETAILS', { cloudstorage: scope.cloudstorage });
          }, 300);
        };

      }
    };
  }

  pxTestCloudStorage.$inject = [
    '$timeout', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxTestCloudStorage', pxTestCloudStorage);

})();
